import { createSlice } from "@reduxjs/toolkit";

import {
  addUnitType,
  deleteUnitType,
  getUnitsTypes,
  updateUnitType,
} from "./thunk";

interface UnitStateType {
  units: Array<any>;
  error?: string | object | null | undefined | unknown;
  success?: string | object | null | undefined | unknown;
}

export const initialState: UnitStateType = {
  units: [],
  error: null,
  success: null,
};

const unitsTypesSlice = createSlice({
  name: "unitsTypes",
  initialState,
  reducers: {
    unitsError(state, action) {
      state.error = action.payload;
    },
    unitsSuccess(state, action) {
      state.success = action.payload;
    },
  },
  extraReducers: builder => {
    builder.addCase(getUnitsTypes.fulfilled, (state: any, action: any) => {
      state.units = action.payload;
    });
    builder.addCase(getUnitsTypes.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(addUnitType.fulfilled, (state: any, action: any) => {
      state.units.push(action.payload);
    });
    builder.addCase(addUnitType.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(updateUnitType.fulfilled, (state: any, action: any) => {
      state.units = state.units.map((unit: any) =>
        unit.id === action.payload.id ? { ...unit, ...action.payload } : unit
      );
    });
    builder.addCase(updateUnitType.rejected, (state, action) => {
      state.error = action.payload || null;
    });
    builder.addCase(deleteUnitType.fulfilled, (state: any, action: any) => {
      state.units = state.units.filter(
        (unit: any) => unit.id !== action.payload
      );
    });
    builder.addCase(deleteUnitType.rejected, (state, action) => {
      state.error = action.payload || null;
    });
  },
});

export const { unitsError, unitsSuccess } = unitsTypesSlice.actions;

export default unitsTypesSlice.reducer;
